<template>
  <div class="page page-products">
    <DefaultHeader />
    <ProductsMenu />
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="section-title">
          <font-awesome-icon icon="star" />
          Mais Consumidos
        </div>
      </div>
    </div>
    <section class="row">
      <product
        v-for="product in getMostConsumed"
        :key="product.id"
        :product="product"
      />
    </section>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="section-title">
          <font-awesome-icon
            :icon="getCurrentCategoryA ? getCurrentCategoryA.icon : ''"
          />
          {{ getCurrentCategoryA ? getCurrentCategoryA.name : "Todos" }}
        </div>
      </div>
    </div>

    <section class="items-container row pb-8rem d-flex">
      <product
        v-for="product in getProductsInCurrentCategory"
        :key="product.id"
        :product="product"
      />
    </section>

    <ProductsFooter />
  </div>
</template>

<script>
  import ProductsMenu from "./ProductsMenu";
  import ProductsFooter from "./ProductsFooter";
  import Product from "./Product";

  import { mapGetters } from "vuex";
  import DefaultHeader from "../DefaultHeader";

  export default {
    name: "Products",
    components: { DefaultHeader, Product, ProductsFooter, ProductsMenu },

    computed: {
      ...mapGetters({
        getProductsInCurrentCategory: "getProductsInCurrentCategory",
        getMostConsumed: "getMostConsumed",
        getCurrentCategory: "getCurrentCategory",
        getCurrentCategoryA: "getCurrentCategoryA",
      }),
    },
    created() {},
    methods: {},
  };
</script>

<style scoped>
  .page-products {
    background-color: #f5e8d9;
  }

  .items-container {
    min-height: calc(46vh);
  }

  .section-title {
    font-size: 30px;
    font-weight: bold;
    color: var(--dark-orange);
    border-bottom: 1px solid var(--light-orange);
  }

  .pb-8rem {
    padding-bottom: 8rem;
  }
</style>

<style></style>
